import React from 'react';

interface TasksDashboard1Props {
    dashboardData?: any;
}

const TasksDashboard1: React.FC<TasksDashboard1Props> = ({ dashboardData }) => {
    const styles = {
        wrapper: {
            position: 'relative' as const,
            paddingBottom: '180px',
            minHeight: '400px',
            backgroundColor: "white"
        },
        tasksContainer: {
            // backgroundImage: "url('/top-green.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'top center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#60A3D9',
            padding: '26px',
            borderRadius: '18px',
            position: 'relative' as const,
            paddingBottom: '60px',
            minHeight: '250px',
        },
        tasksHeader: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '48px',
        },
        menuButton: {
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            background: 'rgba(255, 255, 255, 0.3)',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(10px)',
            transition: 'all 0.2s ease',
        },
        content: {
            maxWidth: '100%',
            paddingTop: '24px',
        },
        title: {
            fontSize: '25px',
            fontWeight: 700,
            color: 'white',
            marginBottom: '8px',
            letterSpacing: '-0.8px',
            lineHeight: '1.1',
        },
        subtitle: {
            fontSize: '15px',
            color: 'white',
            marginBottom: '32px',
            fontWeight: 400,
        },
        taskCount: {
            color: '#2B7A9C',
            textDecoration: 'underline',
            textDecorationThickness: '3px',
            textUnderlineOffset: '5px',
            fontWeight: 500,
        },
        statsGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '12px',
            position: 'absolute' as const,
            left: '26px',
            right: '26px',
            zIndex: 10,
        },
        statCard: {
            background: '#f9f9f9',
            borderRadius: '16px',
            padding: '16px 14px',
            display: 'flex',
            flexDirection: 'column' as const,
            gap: '6px',
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            cursor: 'pointer',
            height: '140px',
            border: '1px solid rgba(0, 0, 0, 0.05)',
        },
        iconWrapper: {
            width: '40px',
            height: '40px',
            borderRadius: '11px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '9px',
        },
        coursesIcon: {
            background: 'rgba(74, 144, 226, 0.12)',
        },
        certificatesIcon: {
            background: 'rgba(123, 165, 232, 0.12)',
        },
        scoreIcon: {
            background: 'rgba(107, 163, 232, 0.12)',
        },
        hoursIcon: {
            background: 'rgba(123, 165, 232, 0.12)',
        },
        statNumber: {
            fontSize: '28px',
            fontWeight: 700,
            color: '#3E5463',
            lineHeight: 1.1,
            letterSpacing: '-0.9px',
        },
        statLabel: {
            fontSize: '14px',
            color: 'black',
            fontWeight: 500,
            letterSpacing: '0.1px',
            marginTop: '4px',
        },
    };

    const listingInitiated = dashboardData?.[0]?.monthlyOrderListing || 0;
    const listingApproved = dashboardData?.[0]?.monthlyOrderConfirmation || 0;
    const poInitiated = dashboardData?.[0]?.monthlyPurchaseOrderListing || 0;
    const poApproved = dashboardData?.[0]?.monthlyPurchaseOrderConfirmation || 0;

    return (
        <div style={styles.wrapper}>
            <div style={styles.tasksContainer}>
                <div style={styles.content}>
                    <p style={styles.title}>Month Summary</p>
                    <p style={styles.subtitle}>
                    </p>

                    <div style={styles.statsGrid}>
                        {/* Listing Initiated Card */}
                        <div
                            style={styles.statCard}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-4px)';
                                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.12)';
                            }}
                        >
                            <div style={{ ...styles.iconWrapper, ...styles.coursesIcon }}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <path d="M16 6L10 9L16 12L22 9L16 6Z" fill="#4A90E2" />
                                    <path d="M10 12V18L16 21L22 18V12" stroke="#4A90E2" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                                </svg>
                            </div>
                            <div style={styles.statNumber}>{listingInitiated}</div>
                            <div style={styles.statLabel}>Listing Initiated</div>
                        </div>

                        {/* Listing Approved Card */}
                        <div
                            style={styles.statCard}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-4px)';
                                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.12)';
                            }}
                        >
                            <div style={{ ...styles.iconWrapper, ...styles.certificatesIcon }}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <rect x="8" y="10" width="16" height="12" rx="1.5" stroke="#7BA5E8" strokeWidth="2.5" fill="none" />
                                    <line x1="11" y1="14" x2="21" y2="14" stroke="#7BA5E8" strokeWidth="2.5" strokeLinecap="round" />
                                    <line x1="11" y1="18" x2="17" y2="18" stroke="#7BA5E8" strokeWidth="2.5" strokeLinecap="round" />
                                </svg>
                            </div>
                            <div style={styles.statNumber}>{listingApproved}</div>
                            <div style={styles.statLabel}>Listing Approved</div>
                        </div>

                        {/* PO Initiated Card */}
                        <div
                            style={styles.statCard}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-4px)';
                                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.12)';
                            }}
                        >
                            <div style={{ ...styles.iconWrapper, ...styles.scoreIcon }}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <circle cx="16" cy="16" r="8" fill="#6BA3E8" />
                                    <circle cx="16" cy="9" r="2.5" fill="#6BA3E8" />
                                    <circle cx="16" cy="23" r="2.5" fill="#6BA3E8" />
                                </svg>
                            </div>
                            <div style={styles.statNumber}>{poInitiated}</div>
                            <div style={styles.statLabel}>PO Initiated</div>
                        </div>

                        {/* PO Approved Card */}
                        <div
                            style={styles.statCard}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-4px)';
                                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.12)';
                            }}
                        >
                            <div style={{ ...styles.iconWrapper, ...styles.hoursIcon }}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <circle cx="16" cy="16" r="2.5" fill="#7BA5E8" />
                                    <line x1="16" y1="10" x2="16" y2="8" stroke="#7BA5E8" strokeWidth="2.5" strokeLinecap="round" />
                                    <line x1="16" y1="24" x2="16" y2="22" stroke="#7BA5E8" strokeWidth="2.5" strokeLinecap="round" />
                                </svg>
                            </div>
                            <div style={styles.statNumber}>{poApproved}</div>
                            <div style={styles.statLabel}>PO Approved</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TasksDashboard1;